import { Box, Paper, Text, TextInput } from '@mantine/core';
import { TContact } from '@/models/contacts';
import PortalAccess from './PortalAccess';

export default function Details({
  contact,
  showPortalAccess = true,
}: {
  contact: TContact;
  showPortalAccess?: boolean;
}) {
  return (
    <Paper my="md" shadow="xs" p="md" maw={960}>
      <Text size="lg" fw={500}>
        {contact.name}
      </Text>
      <Text size="xs" mb="lg">
        {contact.id}
      </Text>

      {showPortalAccess && <PortalAccess contact={contact} />}

      <Box
        style={{
          display: 'flex',
          gap: '16px',
          flexWrap: 'wrap',
        }}
      >
        {contact.column_values.map((cv) => (
          <TextInput
            key={cv.column.id}
            w="100%"
            miw={220}
            maw={'22%'}
            label={cv.column.title}
            value={cv.text ?? ''}
            readOnly
            variant="filled"
          />
        ))}
      </Box>
    </Paper>
  );
}
